import React, { lazy, Suspense, memo } from 'react';

// Map library keys to actual imports
const libraryMap = {
  fa: () => import('react-icons/fa'),
  md: () => import('react-icons/md'),
  ai: () => import('react-icons/ai'),
  bi: () => import('react-icons/bi'),
  bs: () => import('react-icons/bs'),
  // Add more as needed
};

const DynamicIcon = ({ iconName, lib = 'fa', pos="left", iconProps = {} }) => {
  const IconComponent = lazy(() =>
    libraryMap[lib]().then((module) => ({
      default: module[iconName] || (() => null),
    }))
  );

  return (
    <Suspense fallback={null}>
      <IconComponent {...iconProps} style={{
         ...(pos === "left" ? { marginRight: 4 } : { marginLeft: 4 })
        }} />
    </Suspense>
  );
};

export default memo(DynamicIcon);
